<span class="badge badge-pill" [ngClass]="'badge-' + badgeClass">{{stateDisplayValue}}</span>
